import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useAppSelector } from "../../store/hooks";
import {
  useGetFeatureEmailsQuery,
  useSetFeatureEmailsMutation,
} from "../../services/rtkApi/featureEmailsApi";
import { haptic } from "../../utils/haptics";
import styles from "./TelegramSettings.module.css";

/**
 * Opt in or out of the occasional "something new on n450s" email. Account-wide,
 * stored on the backend. The toggle flips at once and the api slice puts it back
 * if the save fails.
 */
const FeatureEmailSettings: React.FC = () => {
  const token = useAppSelector((s) => s.auth.token);
  const { data, isLoading, isError } = useGetFeatureEmailsQuery(undefined, { skip: !token });
  const [save, { isLoading: saving }] = useSetFeatureEmailsMutation();
  const [saveFailed, setSaveFailed] = useState(false);

  const known = typeof data?.subscribed === "boolean";
  const subscribed = known ? !!data?.subscribed : false;
  const loading = !token || isLoading;

  const onToggle = async (checked: boolean) => {
    setSaveFailed(false);
    haptic("selection");
    try {
      await save({ subscribed: checked }).unwrap();
    } catch {
      setSaveFailed(true);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <FontAwesomeIcon icon={faEnvelope} className={styles.titleIcon} />
        Feature emails
      </div>
      <p className={styles.description}>
        Now and then mailbro@n450s.com emails you when something new lands on n450s. Sign-in codes
        and account emails always come, whatever you pick here.
      </p>

      <label className={styles.toggleRow}>
        <input
          type="checkbox"
          checked={subscribed}
          disabled={loading || !known || saving}
          onChange={(e) => void onToggle(e.target.checked)}
        />
        <span>Send me feature emails</span>
      </label>

      {loading && <p className={styles.loadingText}>Loading...</p>}
      {!loading && (isError || !known) && (
        <p className={styles.errorText}>Couldn't load this setting. Try again later.</p>
      )}
      {saveFailed && <p className={styles.errorText}>Couldn't save that. Try again.</p>}
    </div>
  );
};

export default FeatureEmailSettings;
